module.exports = "https://www.gc-qa.gnp.com.mx/d7ac043efc4ac84dd9f383a204eec06d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Banner_PortalSoyCliente-04.png
// module id = 8048
// module chunks = 0